import React from 'react';

const PortletBody = ({
  bgColor,
  withBg,
  className = '',
  style,
  children,
  bare = false,
  raised = false,
  ...props
}) => {
  const hasContent = React.Children.toArray(children).length > 0;
  const emptyClass = !hasContent || bare ? ' portlet__body--empty' : '';
  const raisedClass = raised ? ' portlet__body--raised' : '';

  return (
    <div
      className={`${className} portlet__body${withBg ? '-bg' : ''}${emptyClass}${raisedClass}`}
      style={{ ...style, backgroundColor: bgColor ? bgColor : '' }}
      {...props}
    >
      {children}
    </div>
  );
};

export default PortletBody;
